import { checkExpressionType } from '../../dataset/type-utils';
import { checkExpressionContext } from '../../dataset/context-utils';
/**
 * @throws if violations are found
 */
export const checkViolations = (expression, deps) => {
  const {
    type,
    violations: typeViolations
  } = checkExpressionType(expression, deps);
  const {
    context,
    violations: contextViolations
  } = checkExpressionContext(expression, deps);
  if (!typeViolations.concat(contextViolations).isEmpty()) {
    throw new Error('Cannot create expression field! Violations found.');
  }
  return {
    type,
    context
  };
};